/****************************************************
 * src/modules/profile/onboarding/events.ts
 ****************************************************/
import { BaseEvents } from '@/shared/utils';

export const OnboardingEventKeys = {
  start: {
    view: 'profile/onboarding/start',
    do: 'profile/onboarding/start/do',
  },
  instrument: {
    selection: {
      view: 'profile/onboarding/instrument/selection/view',
      do: 'profile/onboarding/instrument/selection/do',
    },
    child: {
      view: 'profile/onboarding/instrument/child/view',
      do: 'profile/onboarding/instrument/child/do',
      done: 'profile/onboarding/instrument/child/done',
      back: 'profile/onboarding/instrument/child/back',
    },
  },

  studySessions: {
    view: 'profile/onboarding/study-sessions/view',
    selection: {
      do: 'profile/onboarding/study-sessions/selection/do',
      view: 'profile/onboarding/study-sessions/selection/view',
    },
  },

  levelSelection: {
    view: 'profile/onboarding/level-selection/view',
    child: {
      view: 'profile/onboarding/level-selection/child/view',
    },
    selection: {
      view: 'profile/onboarding/level-selection/selection/view',
      do: 'profile/onboarding/level-selection/selection/do',
    },
  },
  end: {
    do: 'profile/onboarding/end/do',
    redirect: 'profile/onboarding/end/redirect',
    redirectDo: 'profile/onboarding/end/redirectDo',
  },
} as const;

export interface OnboardingEvents extends BaseEvents {
  'profile/onboarding/start': void;
  'profile/onboarding/start/do': void;
  // Selezione strumento padre
  'profile/onboarding/instrument/selection/view': void;
  'profile/onboarding/instrument/selection/do': { instrumentName: string };

  // Selezione strumento figlio
  'profile/onboarding/instrument/child/view': { parentName: string };
  'profile/onboarding/instrument/child/do': { childName: string };
  'profile/onboarding/instrument/child/done': void;
  'profile/onboarding/instrument/child/back': void;

  // Step 2
  'profile/onboarding/study-sessions/view': void;
  'profile/onboarding/study-sessions/selection/view': void;
  'profile/onboarding/study-sessions/selection/do': {
    description: string;
  };
  // Step 3
  'profile/onboarding/level-selection/view': void;
  'profile/onboarding/level-selection/selection/view': void;
  'profile/onboarding/level-selection/child/view': void;
  'profile/onboarding/level-selection/selection/do': {
    skillLevel: string;
  };
  'profile/onboarding/end/do': void;
  'profile/onboarding/end/redirect': void;
  'profile/onboarding/end/redirectDo': void;
}
